[
    "abalone",
    "acetato",
    "gliceride di lardo idrogenato acetilato",
    "lanolina acetilata",
    "alcool di lanolina acetilato",
    "ricinoleato di lanolina acetilato",
    "sego acetilato",
    "latte acidophilus",
    "adrenalina",
    "surreni di bovini",
    "surreni di maiali",
    "surreni di pecora",
    "post-nascita",
    "alanina",
    "alcloxa",
    "alcool alifatico",
    "alligatore",
    "pelle di alligatore",
    "alfa-idrossiacidi",
    "ambra grigia",
    "ameracolo",
    "amerchol l101",
    "acido amminiuccinato",
    "caseinato di ammonio",
    "liquido amniotico",
    "proteina animale idrolizzata isoterica ampd",
    "amilasi",
    "acciughe",
    "acciuga",
    "angora",
    "ossa animali",
    "aminoacidi del collagene animale",
    "grasso animale",
    "grassi animali",
    "grassi e oli animali",
    "capelli animali",
    "aminoacidi della cheratina animale",
    "olio animale",
    "oli animali",
    "placenta animale",
    "derivato proteico animale",
    "estratto di tessuto animale",
    "acido arachidonico",
    "aracidilproprionato",
    "astrakan",
    "pancetta posteriore",
    "grasso dorsale",
    "pancetta",
    "basso",
    "alcool batilico",
    "isostearato di batile",
    "orso",
    "polline d'api",
    "prodotti delle api",
    "manzo",
    "cuore di manzo",
    "fegato di manzo",
    "lingua di manzo",
    "polline d'api",
    "cera d'api",
    "nido d'api in cera d'api",
    "pancetta",
    "proteine animali idrolizzate di benziltrimonio",
    "bisonte",
    "sangue",
    "frazionamento del plasma sanguigno",
    "lingua di sangue",
    "setole di cinghiale",
    "prosciutto cotto",
    "cenere d'osso",
    "carbone d'ossa",
    "carbone d'ossa (carbone)/nero d'ossa",
    "carbone d'ossa",
    "terra d'ossa",
    "farina d'ossa",
    "fosfato d'ossa",
    "zuppa d'ossa",
    "farina d'ossa",
    "osso nero",
    "farina di ossa",
    "bonito",
    "sieroalbumina bovina",
    "estratto di cervello",
    "bratwurst",
    "soppressata",
    "pancetta per la colazione",
    "bresaola",
    "bruehwurst",
    "bruhwurst",
    "bufalo",
    "latte di bufala",
    "carne di boscaglia",
    "burro",
    "grasso del burro",
    "solidi del burro",
    "latticello",
    "latticello in polvere",
    "olio di piscina c30-46",
    "calamari",
    "calciferolo",
    "calciferoolo",
    "caseinato di calcio",
    "fegato di vitello",
    "pelle di vitello",
    "estratto di pelle di vitello",
    "latte di cammello",
    "pancetta canadese",
    "cantaradina",
    "tintura di cantaridi",
    "capiz",
    "trigliceride caprilico",
    "carbammide",
    "caribù",
    "carminio",
    "carminio cocciniglia acido carminico",
    "carminio/acido carminico",
    "carminico",
    "acido carminico",
    "carotene",
    "carotene provitamina a beta carotene",
    "carpa",
    "caseina",
    "caseina caseinato",
    "caseinato",
    "caseinogeno",
    "cashmere",
    "ricino",
    "ricino castoreo",
    "castoreo",
    "pesce gatto",
    "gattuccio",
    "cataridina",
    "caviale",
    "caviale(e)",
    "caviare",
    "cera flava",
    "cerebrosidi",
    "ceteth",
    "ceteth-02",
    "ceteth-1",
    "ceteth-10",
    "ceteth-2",
    "ceteth-30",
    "ceteth-4",
    "ceteth-6",
    "cetil lattato",
    "cetil miristato",
    "camoscio",
    "formaggio",
    "pollo",
    "petto di pollo",
    "fegato di pollo",
    "polpettone di pollo",
    "prosciutto crudo",
    "chitosano",
    "colesterina",
    "colesterolo",
    "colina bitartrato",
    "condroitina",
    "prosciutto tritato",
    "chorizo",
    "chimotripsina",
    "burro chiarificato",
    "panna coagulata",
    "cocciniglia",
    "merluzzo",
    "olio di fegato di merluzzo",
    "salumi",
    "coleth-24",
    "collagene",
    "idrolizzato di collagene",
    "latte condensato",
    "glassa per pasticceri",
    "prosciutto cotto",
    "carni cotte",
    "corallo",
    "manzo in scatola",
    "gallina di campagna",
    "cortico steroide",
    "corticosteroide",
    "cortisone corticosteroide",
    "cotechino",
    "ricotta",
    "granchio",
    "polpa di granchio",
    "gamberi",
    "gamberi di fiume",
    "crema",
    "crostacei",
    "cagliata",
    "crema pasticcera",
    "cisteina, forma l",
    "cistina",
    "carne scura",
    "dashi",
    "fosfato di dea-oleth-10",
    "cervo",
    "carne di cervo",
    "siero di latte delattosato",
    "salumi",
    "siero di latte demineralizzato",
    "acido desossiribonucleico",
    "collagene animale desamidato",
    "collagene desamidato",
    "desamidocollagene",
    "devon",
    "dicapryloyl cistina",
    "dietilene tricaseinamide",
    "diidrocolesterolo",
    "diidrocolesterolo ottiledecanoato",
    "diidrocolito-15",
    "diidrocoleth-30",
    "sego diidrogenato benzilmonio cloridrato",
    "metilammina di sego diidrogenato",
    "ftalato di sego diidrogenato",
    "ossido di sego amminico diidrossietilico",
    "dimetil sego idrogenato",
    "dimetil stearamina",
    "dimetil segoammina",
    "glutammato di sego idrogenato disodico",
    "glutammato di sego idrogenato disodico",
    "tallamido mea-solfosuccinato di disodio",
    "tallowaminodipropionato disodico",
    "cloruro di ditallowdimonio",
    "dna",
    "piuma",
    "latticello essiccato",
    "tuorlo d'uovo essiccato",
    "solidi del latte secco",
    "latte intero secco",
    "anatra",
    "pancetta d'anatra",
    "fegato d'anatra",
    "sostanze del duodeno",
    "pagnotta olandese",
    "coloranti",
    "e120",
    "e441",
    "e542",
    "e904",
    "e913",
    "fosfato osseo commestibile",
    "uovo",
    "albume d'uovo",
    "albumina d'uovo/albumina",
    "albumina d'uovo",
    "olio d'uovo",
    "polvere d'uovo",
    "proteine dell'uovo",
    "albume",
    "tuorlo d'uovo",
    "estratto di tuorlo d'uovo",
    "tuorli d'uovo",
    "uova",
    "piumino",
    "elastina",
    "pancetta di alce",
    "estratto di embrione",
    "emu",
    "olio di emu",
    "olio di epidermide r",
    "ergisterolo",
    "ergosterolo",
    "estradiolo benzoato",
    "estrogeno",
    "estrogeno estradiolo",
    "estrogeno/estradiolo",
    "estrone",
    "aracidonato di etile",
    "estere etilico di proteine animali idrolizzate",
    "lipineato di etile",
    "morrhuato di etile lipineato",
    "morrhuatelipineato di etile",
    "etilarachidonato",
    "segoammide deidrogenata di etilene",
    "latte evaporato",
    "latte di pecora",
    "latte senza grassi",
    "yogurt senza grassi",
    "acidi grassi",
    "piume",
    "latte di cammello fermentato",
    "crema fermentata",
    "latte fermentato",
    "pesce",
    "gliceridi di pesce",
    "fegato di pesce",
    "olio di fegato di pesce",
    "fegati di pesce",
    "olio di pesce",
    "salsa di pesce",
    "squame di pesce",
    "salsa di pesce",
    "olio di fletan",
    "pelliccia",
    "gel",
    "gelatina",
    "gel di gelatina",
    "gelatina(e)",
    "gelatina",
    "gelbwurst",
    "ghee",
    "ventrigli",
    "glucosio tirosinasi",
    "acido glucuronico",
    "gliceridi",
    "glicerina glicerolo",
    "glicerina",
    "lanolato di glicerile",
    "gliceroli",
    "glicole",
    "glicreth-26",
    "capra",
    "formaggio di capra",
    "latte di capra",
    "oca",
    "piume d'oca isolanti",
    "fegato d'oca",
    "manzo macinato",
    "gallo cedrone",
    "guanina",
    "essenza di perle di guanina",
    "essenza di guanina/perla",
    "gallina d'India",
    "pancetta zingara",
    "eglefino",
    "pelo di maiale",
    "ippoglosso",
    "prosciutto",
    "pagnotta di prosciutto e formaggio",
    "formaggio di testa",
    "panna pesante",
    "eptilundecanolo",
    "pelle",
    "colla di pelle",
    "latte omogeneizzato",
    "miele",
    "nido d'ape",
    "cavallo",
    "pelo di cavallo",
    "carne di cavallo",
    "crine di cavallo",
    "pelo di maiale",
    "cane caldo",
    "proteina placentare umana",
    "estratto ombelicale umano",
    "acido ialuronico",
    "proteina placentare umana idrolizzata",
    "gliceride animale idrogenato",
    "ammina di ditallow idrogenata",
    "ditallowamina idrogenata",
    "miele idrogenato",
    "laneth-20 idrogenato",
    "laneth-25 idrogenato",
    "laneth-5 idrogenato",
    "lanolina idrogenata",
    "alcool lanolinico idrogenato",
    "gliceride di lardo idrogenato",
    "olio di fegato di squalo idrogenato",
    "acido di sego idrogenato",
    "betaina di sego idrogenata",
    "gliceride di sego idrogenato",
    "elastina animale idrolizzata",
    "cheratina animale idrolizzata",
    "proteine animali idrolizzate",
    "caseina idrolizzata",
    "elastina idrolizzata",
    "proteina placentare umana idrolizzata",
    "cheratina idrolizzata",
    "proteine del latte idrolizzate",
    "seta idrolizzata",
    "lanolina idrossilata",
    "gelato",
    "urea imidazolidinile",
    "caseinato di ferro",
    "isinglass",
    "lanolina isobutilata",
    "lanolato isopropilico",
    "lanolato isopropilico di sego e lanolato isopropilico",
    "palmitato di isopropile",
    "isopropilpalmitato",
    "proteine animali idrolizzate isosteariche",
    "proteine animali idrolizzate isostearoil",
    "jagdwurst",
    "guanciale",
    "canguro",
    "katsuobushi",
    "katsuobushi (okaka)",
    "cheratina",
    "cheratinaminoacidi",
    "l-cisteina",
    "l-cisteina cloridrato",
    "l-forma",
    "latte a ridotto contenuto di lattosio",
    "lattoalbumina",
    "acido lattico dal siero di latte",
    "lieviti lattici",
    "acido lattico",
    "lattoferrina",
    "lattoglobulina",
    "lattosio",
    "latte senza lattosio",
    "lattulosio",
    "agnello",
    "pancetta di agnello",
    "laneth",
    "laneth-10",
    "laneth-11",
    "laneth-12",
    "laneth-13",
    "laneth-14",
    "laneth-15",
    "laneth-16",
    "laneth-17",
    "laneth-18",
    "laneth-19",
    "laneth-20",
    "laneth-21",
    "laneth-22",
    "laneth-23",
    "laneth-24",
    "laneth-25",
    "laneth-26",
    "laneth-27",
    "laneth-28",
    "laneth-29",
    "laneth-30",
    "laneth-31",
    "laneth-32",
    "laneth-33",
    "laneth-34",
    "laneth-35",
    "laneth-36",
    "laneth-37",
    "laneth-38",
    "laneth-39",
    "laneth-40",
    "laneth-5",
    "laneth-6",
    "laneth-7",
    "laneth-8",
    "laneth-9",
    "acetato di laneth-9",
    "acetato di laneth10",
    "lanogene",
    "lanoinamidedea",
    "lanolina",
    "acido lanolinico",
    "acidi di lanolina",
    "alcool lanolinico",
    "alcoli di lanolina",
    "linoleato di lanolina",
    "olio di lanolina",
    "ricinoleato di lanolina",
    "cera di lanolina",
    "lanolina(e)",
    "lanolina",
    "lanolina: acido lanolinico",
    "lanoinamide dea",
    "lanosterolo",
    "lanosteroli",
    "strutto",
    "gliceride di strutto",
    "proteine animali idrolizzate di laurolo",
    "pelle",
    "lecitina colina bitartrato",
    "lecitina colina bitartrato",
    "lipasi",
    "fegato",
    "estratto di fegato",
    "salsiccia di fegato",
    "aragosta",
    "latte magro",
    "yogurt magro",
    "spugna di luna",
    "lunasponge",
    "pagnotta luncehon",
    "carni da pranzo",
    "carni per il pranzo",
    "sgombro",
    "caseinato di magnesio",
    "lanolato di magnesio",
    "segoato di magnesio",
    "latte maltato",
    "estratto di mammifero",
    "olio marino",
    "zuppa di midollo",
    "maionese",
    "proteine animali idrolizzate",
    "carne",
    "polpettone",
    "polpetta",
    "pollo separato meccanicamente",
    "olio di menadino",
    "metionina",
    "mettwurst",
    "latte",
    "cioccolato al latte",
    "derivato del latte",
    "latte di mammiferi",
    "latte in polvere",
    "proteine del latte",
    "pelle del latte",
    "zucchero del latte",
    "grasso di latte",
    "polvere di latte",
    "manzo macinato",
    "carne macinata",
    "olio di visone",
    "minkamidopropyl dietilammina",
    "mohair",
    "molluschi",
    "rana pescatrice",
    "alce",
    "mortadella",
    "olio di muschio",
    "mucopolisaccaridi",
    "triglia",
    "estratto di muscolo",
    "ambretta di muschio",
    "cozza",
    "cozze",
    "montone",
    "miristato acido",
    "proteine animali idrolizzate di miristoile",
    "miristile",
    "miristili",
    "aroma naturale di burro",
    "rosso naturale 4",
    "collo",
    "latte magro",
    "torrone",
    "ocenolo",
    "polpo",
    "okaka",
    "proteine animali idrolizzate di oleamidopropil dimetilammina",
    "oleostearina",
    "oleostearina",
    "proteine animali idrolizzate oleoiliche",
    "oleths",
    "oleil arachidato",
    "oleil betatina",
    "oleil imidazolina",
    "oleil lanolato",
    "oleil oleato",
    "stearato di oleile",
    "oleilalcol ocenolo",
    "oleilimidazolina",
    "acidi grassi omega-3",
    "opossum",
    "carne d'organo",
    "carni d'organo",
    "organi",
    "struzzo",
    "ovalbumina",
    "estratto ovarico",
    "bile di bue",
    "bile di bue",
    "bile di bue",
    "ostrica",
    "ostriche",
    "proteine del latte idrolizzate di palmitoile",
    "proteine animali idrolizzate di palmitoile",
    "pancetta",
    "paracaseina",
    "pernice",
    "latte pastorizzato",
    "perla",
    "essenza di perla",
    "peg-13 amido di sego idrogenato",
    "peg-15 poliammina di sego",
    "peg-2 solidi del latte",
    "peg-20 segoato",
    "peg-28 sego glicerilico",
    "peg-75 olio e cera di lanolina",
    "peg-8 gliceridi di pesce idrogenati",
    "pentaidrosqualene",
    "pepsina",
    "peridrosqualene",
    "smalto farmaceutico",
    "fagiano",
    "spalla da picnic",
    "estratto di pelle di maiale",
    "placenta",
    "proteine polipeptidiche della placenta",
    "enzimi della placenta",
    "estratto di placenta",
    "proteina placentare",
    "platessa",
    "olio di platessa",
    "pollock",
    "poltetilene",
    "poltetilene cetil etere",
    "poliglicerolo",
    "poliglicerolo-2 lanolina alcool etere",
    "polipeptidi proteici",
    "pancreas suino",
    "maiale",
    "grasso di maiale",
    "rotolo di maiale",
    "caseinato di potassio",
    "segoato di potassio",
    "proteine animali idrolizzate di potassio undecylenoyl",
    "pollame",
    "ppg-12-peg-50 lanolina",
    "ppg-2 metil etere",
    "ppg-5-ceteth-20",
    "ppg-10",
    "ppg-20 metil glucosio etere",
    "ppg-30 etere cetilico",
    "ppg-30 lanolina etere",
    "gambero",
    "pregnenolone acetato",
    "pristano",
    "propoli",
    "prosciutto",
    "provitamina a",
    "olio di purcellina syn",
    "quaglia",
    "quaternio 27",
    "coniglio",
    "carne rossa",
    "latte a ridotto contenuto di grassi",
    "yogurt a ridotto contenuto di grassi",
    "caglio di caseina",
    "glassa resinosa",
    "reticulina",
    "retinolo",
    "arrosto di manzo",
    "arrosto di maiale",
    "bottarga",
    "pappa reale",
    "zibellino",
    "spazzole di zibellino",
    "saccaride isomerato",
    "salame",
    "salceson",
    "salmone",
    "sardina",
    "salsiccia",
    "salsicce",
    "capasanta",
    "capesante",
    "spugna di mare",
    "olio di tartaruga marina",
    "spugna di mare",
    "sieroalbumina",
    "proteine del siero",
    "olio di fegato di squalo",
    "olio di fegato di squalo",
    "latte di pecora",
    "pelle di pecora",
    "pelle di pecora",
    "gommalacca",
    "smalto resinoso di gommalacca",
    "cera di gommalacca",
    "spalla",
    "gambero",
    "gambero",
    "pancetta laterale",
    "seta",
    "aminoacidi della seta",
    "polvere di seta",
    "seta in polvere",
    "latte scremato",
    "pelle",
    "pancetta a fette",
    "affettati",
    "prosciutto affumicato",
    "lumaca",
    "lumache",
    "serpente",
    "dentice",
    "proteine animali idrolizzate di sodio/tè-lauree",
    "proteine animali idrolizzate di sodio/tè-undecilenoile",
    "caseinato di sodio",
    "proteine animali idrolizzate di sodio da cocco",
    "proteine animali idrolizzate di sodio della soia",
    "sego solfato di sodio",
    "segoato di sodio",
    "sodio undecilenato",
    "sodio steroil lattilato",
    "sodio steroil lattilato",
    "collagene solubile",
    "panna acida",
    "latte acido",
    "solidi del latte acido",
    "latte inacidito",
    "soia idrossietil imidazolina",
    "olio di sperma",
    "intestino di capodoglio",
    "spermaceti",
    "olio di sperma spermacetile palmitato",
    "estratto di milza",
    "spugna (luna e mare)",
    "piccione",
    "calamaro",
    "scoiattolo",
    "bistecca",
    "stearildimetilammina",
    "steroidi steroli",
    "steroli",
    "bistecca",
    "stiletto",
    "pancetta striata",
    "siero di latte dolce",
    "siero di latte dolce",
    "animelle",
    "latte condensato zuccherato",
    "pesce spada",
    "sego",
    "sego acido",
    "amide di sego",
    "sego ammina",
    "ossido di sego amminico",
    "aminopropilammina di sego",
    "alcool grasso di sego",
    "gliceridi di sego",
    "imidazolina idrossietale di sego",
    "imidazolina di sego",
    "sego cloruro di trimonio - sego",
    "ossido di sego-amidopropilammina",
    "segoet-6",
    "sego-mide dea",
    "sego-mide dea e mea",
    "sego-mide mea",
    "segoidopropile idrossisultaina",
    "segominopropilammina",
    "segofaceto",
    "proteine animali idrolizzate di tè-abietoile",
    "proteine animali idrolizzate di tè-coco",
    "aminoacidi del collagene animale di tè-laurolo",
    "aminoacidi della cheratina animale di tè-laurolo",
    "proteine animali idrolizzate di tè-miristolo",
    "proteine animali idrolizzate di tè-undecilenoile",
    "estratto testicolare",
    "salsiccia turingia",
    "tilapia",
    "lingua",
    "etosolfato di proteine animali idrolizzate di trietonio",
    "trilaneth-4fosfato",
    "trippa",
    "alcoli triterpenici",
    "trota",
    "tripsina",
    "tonno",
    "tacchino",
    "pancetta di tacchino",
    "petto di tacchino",
    "tartaruga",
    "olio di tartaruga",
    "olio di tartaruga marina",
    "tirosina",
    "latte non omogeneizzato",
    "urea",
    "urea carbammide",
    "acido urico",
    "acido urico di mucca",
    "acido urico",
    "urina",
    "vitello",
    "polpettone di vitello",
    "carne di cervo",
    "vitamina d ergocalciferolo vitamina d",
    "vitamina h",
    "vitamina b",
    "fattore vitamina b",
    "volaise",
    "siero di latte",
    "siero di latte in polvere",
    "proteine del siero di latte",
    "panna montata",
    "guarnizione montata",
    "carne bianca",
    "latte intero",
    "yogurt da latte intero",
    "cinghiale",
    "carne selvatica",
    "lana",
    "grasso di lana",
    "cera di lana",
    "alcoli di cera di lana",
    "yogurt",
    "yogurt",
    "zinco caseinato",
    "proteine animali idrolizzate di zinco"
]
